<template>
	<div
		v-if="availablePackages.length > 0 && showPremiumPackage && featuredServices.length > 0"
		class="container py-10 bg-00953A"
	>
		<div class="text-center mb-6 text-white">
			<h2 class="text-white">Save More With A Package!</h2>

			<div>
				By packaging popular add-ons to your Lawn Service Program, you can save.
			</div>
		</div>

		<div :class="gridClasses" class="txt-00953A" v-for="(service, index) in availablePackages" :key="index">
			<PackageServiceCard :service="service" :size="size" />
		</div>
		<div :class="gridClasses" class="txt-00953A" v-if="featuredServices && featuredServices.length > 0"	>
			<ServicesCardList 
				:services="featuredServices"
				borderOverride="orange"
				:hidePurchased="true"
				size="large"
				packageServices="true"
			/>
		</div>

		<div class="text-center mb-6 text-white mt-10" v-if="packageBtn">
			<NuxtLink to="/services/lawn-care-services/" class="button"
				style="border: 1px solid #fff; background: transparent; max-width: fit-content; padding: 1rem;">
				Explore All Lawn Care Programs
			</NuxtLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import type { Store } from 'vuex/types/index.js';
import type State from '~/domains/store/State';
import PackageServiceCard from './PackageServiceCard.vue';
import type UPPackageState from '~/domains/store/branchinfo/UPPackageState';
import type ServiceState from '~/domains/store/services/ServiceState';

const store: Store<State> = useStore();
const { $services } = useNuxtApp();

const props = defineProps({
	size: {
		type: String,
		default: 'md',
	},
	packageBtn: {
		type: Boolean,
		default: true,
	}
});

const emit = defineEmits(['isPackageAvailable']);

const availablePackages = computed<UPPackageState[]>(() => {
	const persistedState = store.state.persistedState;
	if (!persistedState) return [];

	const upPackage = persistedState?.branchInfo?.UPPackage;
	const IMCYear = persistedState?.branchInfo?.IMCYear;

	if (upPackage) {
		return upPackage.filter((item) => item.Year === IMCYear);
	}
	return [];
});

const showPremiumPackage = computed<boolean>(() => {
	return !!store.state.persistedState?.customer?.size;
});

const featuredServices = computed<ServiceState[]>(() => {
	return $services.getServicesByIds([2, 3], true, false);
});

const gridClasses = computed<string>(() => {
	if (props.size === "medium") {
		return "grid md:grid-cols-2 gap-4 clear-both mb-8";
	} else if (props.size === "small") {
		return "grid lg:grid-cols-3 gap-4";
	}
	return "";
});

// Compute isPackageAvailable and emit its value reactively
const isPackageAvailable = computed<boolean>(() => availablePackages.value.length > 0);
watchEffect(() => {
  emit('isPackageAvailable', isPackageAvailable.value);
});
</script>

<style scoped>
.bg-00953A {
	background: #00953a;
}
</style>
